<template>
    <div id="menu-box" style="display: block;">
        <div id="menu-background" style="visibility: hidden; opacity: 0;" @click="hide_menu();"></div>
        <div id="menu-content" style="transform: translateX(100%); will-change: transform;">
            <div class="menu-body">
                <div class="row">
                    <div class="col-12 menu-body-title">
                        Menu
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 menu-body-item">
                        <router-link to="/" class="menu-body-link" data-magnetic=""  @click="hide_menu();">
                            <em>
                                <span data-text="Accueil">
                                    Accueil
                                </span>
                            </em>
                        </router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 menu-body-item">
                        <router-link to="/projets" class="menu-body-link" data-magnetic=""  @click="hide_menu();">
                            <em>
                                <span data-text="Projets">
                                    Projets
                                </span>
                            </em>
                        </router-link>
                    </div>
                </div>
                <!--
                <div class="row">
                    <div class="col-12 menu-body-item">
                        <router-link to="/ecole" class="menu-body-link" data-magnetic=""  @click="hide_menu();">
                            <em>
                                <span data-text="École">
                                    École
                                </span>
                            </em>
                        </router-link>
                    </div>
                </div>
                -->
                <div class="row">
                    <div class="col-12 menu-body-item">
                        <router-link to="/partenaires" class="menu-body-link" data-magnetic=""  @click="hide_menu();">
                            <em>
                                <span data-text="Partenaires">
                                    Partenaires
                                </span>
                            </em>
                        </router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 menu-body-item">
                        <router-link to="/contacts" class="menu-body-link" data-magnetic=""  @click="hide_menu();">
                            <em>
                                <span data-text="Contacts">
                                    Contacts
                                </span>
                            </em>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="menu-contact">
                <div class="row">
                    <div class="col-12 menu-contact-title">
                        Restons en contact
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 menu-contact-item">
                        <a href="mailto:originsprods@gmail.com" class="menu-contact-link">
                            <span>originsprods@gmail.com</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MenuComponent",
        methods: {
            hide_menu: function(){
                var menu_background = document.getElementById("menu-background");
                var menu_content = document.getElementById("menu-content");

                var first_span = document.querySelector('.menu-button-logo').firstChild;
                var last_span = document.querySelector('.menu-button-logo').lastChild;

                var body = document.querySelector('body');

                menu_background.style.opacity = 0;
                menu_background.style.visibility = "hidden";

                menu_content.style.transform = "translateX(100%)";

                first_span.style.transform = "none";
                first_span.style.top = "0";
                last_span.style.transform = "none";
                last_span.style.top = "0";

                body.style.overflow = "unset";
            }
        }
    }
</script>

<style lang="scss">

    em {
        font-style: normal;
    }

    #menu-background {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 197;
        visibility: hidden;
        opacity: 0;
        transition: .3s;
        background: #000;
    }

    #menu-content {
        position: fixed;
        top: 0;
        right: 0;
        left: auto;
        height: 100vh;
        width: 40%;
        z-index: 200;
        background: #fff;
        padding: 3em 0 3em 0;
        transition: transform .3s;
        overflow-y: unset;
    }

    @media (max-height: 750px) {
        #menu-content {
            overflow-y: scroll;
        }
    }


    .menu-body, .menu-contact {
        padding-left: 30%;
        padding-top: 3em;
    }

    .menu-body-title, .menu-contact-title {
        font-size: 1.1em;
        color: #6d6d6d;
    }

    .menu-body-item {
        font-size: 1.8em;
        padding-top: 0.7em;
        font-weight: bold;
    }

    .menu-body-link {
        color: #000;
        text-decoration: none;
        display: inline-block;
        position: relative;
        line-height: 100%;
        font-weight: 400;
    }

    .menu-body-link::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: -2px;
        height: 1px;
        transform: scaleX(0);
        transform-origin: right center;
        background: #fff;
        transition: transform .5s,transform-origin 0s,
            -webkit-transform .5s,
            -moz-transform .5s,
            -o-transform .5s,
            -webkit-transform-origin 0s,
            -moz-transform-origin 0s,
            -ms-transform-origin 0s,
            -o-transform-origin 0s;
    }

    .menu-body-link em {
        display: block;
        position: relative;
        overflow: hidden;
        padding: 0 .01em 0 0;
    }

    .menu-body-link span {
        display: inline-block;
        color: transparent;
        transition: transform 1.2s cubic-bezier(.19,1,.22,1),
            -webkit-transform 1.2s cubic-bezier(.19,1,.22,1),
            -moz-transform 1.2s cubic-bezier(.19,1,.22,1),
            -o-transform 1.2s cubic-bezier(.19,1,.22,1);
    }

    .menu-body-link span::before, .menu-body-link span::after {
        content: attr(data-text);
        display: block;
        position: absolute;
        color: #000;
    }

    .menu-body-link span::before {
        top: 0;
        transform: skewY(0);
        transform-origin: right bottom;
        transition: transform 2s cubic-bezier(.19,1,.22,1),
            -webkit-transform 2s cubic-bezier(.19,1,.22,1),
            -moz-transform 2s cubic-bezier(.19,1,.22,1),
            -o-transform 2s cubic-bezier(.19,1,.22,1);
    }

    .menu-body-link span::after {
        top: 105%;
        transform: skewY(7deg);
        transform-origin: left top;
        transition: transform 2s cubic-bezier(.19,1,.22,1),
            -webkit-transform 2s cubic-bezier(.19,1,.22,1),
            -moz-transform 2s cubic-bezier(.19,1,.22,1),
            -o-transform 2s cubic-bezier(.19,1,.22,1);
    }

    .menu-body-link:hover {
        color: #000;
        text-decoration: none;
        cursor: pointer;

        span {
            transform: translateY(-105%);
        }

        span::before {
            transform: skewY(7deg);
        }

        span::after {
            transform: skewY(0);
        }
    }

    .menu-contact-link {
        position: relative;
        padding: 0 0 5px 0;
        color: #000;
        text-decoration: none;
    }

    .menu-contact-link::before {
        background: lightgray;
    }

    .menu-contact-link::after {
        background: #000;
        transform: scaleX(0);
        transition: transform .8s cubic-bezier(.19,1,.22,1),
            -webkit-transform .8s cubic-bezier(.19,1,.22,1),
            -moz-transform .8s cubic-bezier(.19,1,.22,1),
            -o-transform .8s cubic-bezier(.19,1,.22,1);
    }

    .menu-contact-link::after, .menu-contact-link::before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 2px;
    }

    .menu-contact-link:hover {
        color: #000;
    }

    .menu-contact-link:hover::after {
        transform: scaleX(1);
    }

    @media (max-width: 960px)
    {
        #menu-content {
            width: 60%;
        }
    }

    @media (max-width: 560px)
    {
        #menu-content {
            width: 80%;
        }
    }

    @media (max-width: 420px)
    {
        #menu-content {
            width: 100%;
        }
    }
</style>